import createSagaMiddleware from "redux-saga";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers/rootReducer";
import rootSaga from "./sagas/rootSaga";
import { selectedAccountsPersistenceMiddleware } from "./entities/accounts/model/selected-accounts.persistence";
import { registerReduxAppStore } from "./entities/lib/redux-app-store";

export const sagaMiddleware = createSagaMiddleware();

// Legacy export for backwards compatibility - will be removed in future
export const skedMiddlewares = [sagaMiddleware];

export const createStoreHelper = (preloadState = {}) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState: preloadState,
    middleware: (getDefaultMiddleware) => [
      ...getDefaultMiddleware({
        // Disable serializable check for now - can be enabled after cleanup
        serializableCheck: false,
        // Disable immutable check in production for performance
        immutableCheck: process.env.NODE_ENV !== "production",
      }),
      selectedAccountsPersistenceMiddleware.middleware,
      sagaMiddleware,
    ],
    devTools: process.env.NODE_ENV !== "production",
  });
};

export const Store = createStoreHelper();
registerReduxAppStore(Store);

sagaMiddleware.run(rootSaga);
